import { observer } from "mobx-react-lite";
import * as React from "react";
import { catalogBaseColumns } from "src/business/catalog/catalogColumns";
import { ZCatalog } from "src/business/catalog/ZCatalog";
import { MdmTable } from "src/components/MdmTable";
import { RtSelection } from "src/components/ReactiveTable/components/RtSelection";
import { RtKey } from "src/components/ReactiveTable/RtTypes";
import { ToolBox2 } from "src/components/ToolBox2";

import { SecSpecSelectStore } from "../SecSpecSelectStore";
import * as styles from "./shared.module.less";

type PropsSelectCatalogStep = {
  store: SecSpecSelectStore;
};

export const SelectCatalogStep: React.FC<PropsSelectCatalogStep> = observer(
  ({ store }) => {
    const { catalogsStore } = store;

    if (!catalogsStore) return null;
    return (
      <ToolBox2
        mainTool={
          <>
            <div className={styles.stepHeader}>
              2. Выберите каталог для трансляции атрибутов
            </div>
            <RtSelection store={catalogsStore} makeOption={makeCatalogOption} />
          </>
        }
      >
        <MdmTable
          store={catalogsStore}
          columns={catalogBaseColumns}
          resizableColumns
          rowClick={{
            type: "click",
            handler: (row) => catalogsStore?.changeSelection(row.id, "toggle"),
          }}
        />
      </ToolBox2>
    );
  },
);

const makeCatalogOption = (
  key: RtKey,
  row?: ZCatalog,
): { value: RtKey; label: React.ReactNode } => ({
  value: key,
  label: row?.name ?? key,
});
